import '../../../styles/index.css'
import './ModalSalvarSetup.css';
import CustomButton from './../../Buttons/CustomButton/CustomButton';
import { apiUser } from '../../../api/api';
import { ToastContainer, toast } from 'react-toastify';
import $ from 'jquery';

function ModalSalvarSetup({ email }) {

    console.log('email: ', email)

    const onClickSalvarSetup = (event) => {

        event.preventDefault();

        const nomeDoSetup = $('#inputNomeSetup').val()

        apiUser.salvaSetup(email, { name: nomeDoSetup, url: window.location.pathname + window.location.search }).then((response) => {
            console.log('Setup salvo com sucesso!');
            console.log(response);
            $('#botaoFecharModalSalvarSetup').click();
            document.getElementById('inputNomeSetup').value = '';
            window.scrollTo({ top: 0, behavior: 'smooth' });
            toast("Setup salvo com sucesso!")
        }).catch((error) => {
            console.log(error);
        })

    }

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                theme="light"
            />

            <div className="modal fade" id="modalSalvarSetup" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Salvar Setup</h1>
                            <button type="button" id='botaoFecharModalSalvarSetup' className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">

                            <form onSubmit={onClickSalvarSetup} className='corpoModalSalvarSetup'>

                                <p className='b2'>Dê um nome ao Setup criado, para ver mais tarde e poder compartilhar com os amigos.</p>

                                <div className='d-flex flex-column gap-2'>
                                    <label className='s2 negrito' htmlFor="inputNomeSetup">Nome do Setup:</label>
                                    <input type="text" id='inputNomeSetup' required />
                                </div>

                                <div className='d-flex justify-content-center'>
                                    <CustomButton type='submit' texto={'Confirmar'} cor={'#A80A01'} tipo='3' />
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ModalSalvarSetup;
